function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m61 497v-278.007c0-4.686 2.19-9.104 5.92-11.94l180.042-136.91c5.367-4.081 12.797-4.08 18.162.002l179.958 136.91c3.729 2.837 5.918 7.253 5.918 11.938v278.007z",
  fill: "#f6f9f9"
}), /*#__PURE__*/React.createElement("path", {
  d: "m445.082 207.055-179.958-136.909c-2.695-2.05-5.91-3.069-9.124-3.06v429.914h195v-278.007c0-4.685-2.189-9.101-5.918-11.938z",
  fill: "#e4e4e7"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m256 82.584 203.772 153.378c6.604 5.003 16.013 3.705 21.015-2.899l27.17-35.87c5.002-6.603 3.704-16.011-2.899-21.013l-221.894-167.105c-15.994-12.101-38.334-12.101-54.335.006l-221.887 167.098c-6.603 5.002-7.901 14.41-2.899 21.013l27.17 35.87c5.002 6.604 14.411 7.902 21.015 2.899z",
  fill: "#ff5064"
}), /*#__PURE__*/React.createElement("path", {
  d: "m505.058 176.179-221.894-167.104c-7.997-6.05-17.58-9.075-27.164-9.075v82.584l203.772 153.378c6.604 5.003 16.013 3.705 21.015-2.899l27.17-35.87c5.002-6.604 3.704-16.012-2.899-21.014z",
  fill: "#f52837"
})), /*#__PURE__*/React.createElement("path", {
  d: "m331 497v-160c0-8.284-6.716-15-15-15h-120c-8.284 0-15 6.716-15 15v160z",
  fill: "#6ba7ff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m376 392c-8.284 0-15-6.716-15-15v-40c0-8.284 6.716-15 15-15s15 6.716 15 15v40c0 8.284-6.716 15-15 15z",
  fill: "#bceaf9"
}), /*#__PURE__*/React.createElement("path", {
  d: "m316 322h-60v175h75v-160c0-8.284-6.716-15-15-15z",
  fill: "#4793ff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m256 280c-24.813 0-45-20.187-45-45s20.187-45 45-45 45 20.187 45 45-20.187 45-45 45z",
  fill: "#6ba7ff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m301 235c0-24.813-20.187-45-45-45v90c24.813 0 45-20.187 45-45z",
  fill: "#4793ff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m256 250c-8.271 0-15-6.729-15-15s6.729-15 15-15 15 6.729 15 15-6.729 15-15 15z",
  fill: "#d8f1fb"
}), /*#__PURE__*/React.createElement("path", {
  d: "m271 235c0-8.271-6.729-15-15-15v30c8.271 0 15-6.729 15-15z",
  fill: "#bceaf9"
}), /*#__PURE__*/React.createElement("path", {
  d: "m211 352h30v130h-30z",
  fill: "#d8f1fb"
}), /*#__PURE__*/React.createElement("path", {
  d: "m271 352h30v130h-30z",
  fill: "#bceaf9"
}), /*#__PURE__*/React.createElement("path", {
  d: "m136 392c-8.284 0-15-6.716-15-15v-40c0-8.284 6.716-15 15-15s15 6.716 15 15v40c0 8.284-6.716 15-15 15z",
  fill: "#d8f1fb"
}), /*#__PURE__*/React.createElement("path", {
  d: "m497 512h-482c-8.284 0-15-6.716-15-15s6.716-15 15-15h482c8.284 0 15 6.716 15 15s-6.716 15-15 15z",
  fill: "#9bda05"
}), /*#__PURE__*/React.createElement("path", {
  d: "m497 482h-241v30h241c8.284 0 15-6.716 15-15s-6.716-15-15-15z",
  fill: "#80b405"
}));

var Svg006Home = function Svg006Home(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg006Home, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/006-home.87914ce7.svg";
export { ForwardRef as ReactComponent };